<template>
  <div>
    <Form inline label-position="left" :label-width="0">
      <Row :gutter="10">
        <Col :xs="24" :sm="24" :md="12" :lg="8">
          <FormItem style="width:100%">
            <Input
              v-model="searchItem.param"
              style="width:100%"
              placeholder="请输入关键词"
            ></Input>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="1">
          <Button type="primary" @click="getData()"
            ><!-- 检索 -->{{ $t("Search") }}</Button
          >
        </Col>
      </Row>
    </Form>
    <div style="display: flex;justify-content: flex-end;margin-bottom: 15px;">
      <Button @click="(type = 1), (modalShow = true)"
        ><!-- 上传 -->{{ $t("Upload_File") }}</Button
      >
    </div>

    <Table border :loading="loading" :columns="columns" :data="data">
      <template slot="action" slot-scope="{ row, index }">
        <Button size="small" @click="editRow(row, index)"
          ><!-- 管理 -->{{ $t("Admin") }}</Button
        >
        <Button
          size="small"
          style="margin-left:15px"
          type="error"
          @click="deleteRow(row, index)"
          ><!-- 删除 -->{{ $t("Delete") }}</Button
        >
      </template>
    </Table>
    <div style="display: flex;justify-content: flex-end;margin-top: 30px;">
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        transfer
        :page-size="pageInfo.pageSize"
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
    </div>

    <Modal
      v-model="modalShow"
      :title="type == 1 ? $t('File_Name') : $t('Admin')"
      width="500"
    >
      <Form label-position="left" :label-width="120">
        <Row :gutter="10">
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <FormItem :label="$t('Page_Name')">
              <Input v-model="formItem.page"></Input>
            </FormItem>
          </Col>
        </Row>
        <div style="display:flex;align-items: center;">
          <!-- 20480 -->
          <Upload
            :action="action"
            :max-size="20480"
            :show-upload-list="false"
            :on-success="uploadFiled"
            :before-upload="handleBeforeUpload"
            :on-error="handleUpload"
          >
            <Button type="primary"
              ><!-- 点击上传 -->{{ $t("Click_Upload") }}</Button
            >
          </Upload>
          <span style="margin:0 15px">{{ formItem.resourceName }}</span>
          <!-- <Icon v-if="formItem.fileName==''?false:true" type="md-trash" style="color: red" @click="clearFiled()"/> -->
        </div>

        <p style="margin-top:15px">文件大小不可超过20M。</p>
      </Form>
      <div slot="footer">
        <Button @click="modalSave"><!-- 保存 -->{{ $t("Save") }}</Button>
        <Button @click="(modalShow = false), (formItem = { resourceName: '' })"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      searchItem: {},
      formItem: {
        resourceName: ""
      },
      modalShow: false,
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data: [],
      type: 1,
      action: "/api/resource/upload"
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns() {
      return [
        {
          title: this.$t("File_Name") /* 文件名称 */,
          key: "resourceName",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("Page_Name") /* 页面名称 */,
          key: "page",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("File_Admin") /* 管理员 */,
          key: "adminUserName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action",
          align: "center",
          minWidth: 120
        }
      ];
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      axios
        .post("/carlsbergFile/selectCarlsbergFileList", {
          ...this.pageInfo,
          ...this.searchItem
        })
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = parseInt(res.pageInfo.total);
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    editRow(row, index) {
      this.type = 0;
      this.formItem = row;
      this.modalShow = true;
    },
    deleteRow(row, index) {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          this.loading = true;
          axios
            .post("/carlsbergFile/deleteCarlsbergFile", { id: row.id })
            .then(res => {
              this.loading = false;
              if (res) {
                this.$Message.info(`删除成功`);
                this.getData();
              }
            });
        }
      });
    },
    uploadFiled(response, file, fileList) {
      this.formItem.resourceName = file.name;
      this.formItem.resourceId = response.data;
    },
    handleUpload(response, file, fileList) {},
    handleBeforeUpload(file) {
      if (file.size / 1024 > 20480) {
        this.$Message.warning(`文件大小不可超过20M `);
        return false;
      }
      // file.url = this.convertSrc(file);
      // let segmentation= file.name.split(".");
      // if (
      //     segmentation[segmentation.length - 1] == "png" ||
      //     segmentation[segmentation.length - 1] == "jpg" ||
      //     segmentation[segmentation.length - 1] == "pdf"
      // ) {
      //     return true
      // } else {
      //     this.$Message.warning(`上传类型只能是jpg,png,pdf`);
      //     return false;
      // }
    },
    modalSave() {
      if (this.formItem.page == "" || !this.formItem.page) {
        this.$Message.warning(`页面名称不能为空`);
        return;
      }
      if (this.formItem.resourceId == "" || !this.formItem.resourceId) {
        this.$Message.warning(`请上传文件`);
        return;
      }
      axios
        .post("/carlsbergFile/updateCarlsbergFile", this.formItem)
        .then(res => {
          if (res) {
            this.$Message.info(this.$t(`Save_Successful`));
            this.modalShow = false;
            this.formItem = { resourceName: "" };
            this.getData();
          }
        });
    },
    convertSrc(file) {
      return window.URL.createObjectURL(file);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/index/CarlsbergFileAdmin.vue